import '@adyen/adyen-web/dist/adyen.css';

import { PaymentAction } from '@adyen/adyen-web/dist/types/types';
import React from 'react';

import ShopCheckoutActionCreator from '../ShopCheckoutActionCreator/ShopCheckoutActionCreator';

import SentryErrorBoundary from '@components/SentryErrorBoundary/SentryErrorBoundary';
import useAuthorizationActionErrorLogger from '@hooks/useErrorLogger';
import ConfigProvider from '@providers/ConfigProvider';
import I18nProvider from '@providers/I18nProvider';
import { Environment, Locale, PaymentMethod, ShopBundle } from '@types-internal';

export type PaymentAuthorizationActionProps = {
  shopBundle: ShopBundle;
  locale: Locale;
  paymentMethod: PaymentMethod;
  csrfToken: string;
  domain: string;
  paymentId: string;
  paymentAction: PaymentAction;
  env: Environment;
  customerId?: string;
  storeCardDetails?: boolean;
  processPaymentDetailsUrl: string;
  isMobileApp: boolean;
  currency?: string;
  sid?: string;
  siteId?: number;
  customerType?: string;
  /**
   * On timeout or retry exhaustion, submit to processPaymentDetailsUrl instead of the
   * legacy Finish/app-payment-router redirects. Defaults to the legacy redirects (used by
   * the self-mounting shop bundle in index.tsx). The library export (PaymentAuthorization)
   * forces this on so checkout-frontend routes the final navigation through
   * processPaymentDetailsUrl and shop-checkout owns the Finish (?zpp=failed) + deeplink.
   */
  redirectFailureToProcessUrl?: boolean;
};

const PaymentAuthorizationAction: React.FC<PaymentAuthorizationActionProps> = props => {
  const { shopBundle, locale, paymentId, paymentMethod, env } = props;
  useAuthorizationActionErrorLogger({ paymentId, paymentMethod });

  return (
    <ConfigProvider env={env} shopBundle={shopBundle}>
      <I18nProvider env={env} shopBundle={shopBundle} locale={locale}>
        <SentryErrorBoundary featureName="action-creator">
          <ShopCheckoutActionCreator {...props} />
        </SentryErrorBoundary>
      </I18nProvider>
    </ConfigProvider>
  );
};

export default PaymentAuthorizationAction;
